import React from 'react';
import { Ticket , CaretRight } from '@phosphor-icons/react';
import './style';

const TicketCard = ({type, onClick, category}) => {
  // console.log(category)
  return (
    <div
      className={`w-full p-5 flex gap-3 rounded-[12px] items-center ${type === 'active' ? 'active' : 'disabled'}`}
      onClick={onClick}
    >
      <div className="flex flex-col gap-1">
        <h1 className="ticketCardHeading">{category.categoryName}</h1>
        <div className="flex gap-1 items-center">
          <Ticket size={20} />
          <p className="text-14 md:text-16">
            {category.availableTicket} tickets available
          </p>
        </div>
      </div>

      <div className="ml-auto flex flex-col gap-1 items-center">
        <p className="text-[#009D64] font-[500]">₹ {category.startingPrice} </p>
        <p className="text-[#009D64]">onward</p>
      </div>

      <CaretRight size={24}
        fill="#B7B7B7" />
    </div>
  );
  
};

export default TicketCard;
